import { createSelector } from 'reselect';
import reducerRegistry from '@comeon/reducer-registry';
import { basicApiErrorHandler } from './we-spin-error-handler.js';
import { createApiAction } from '~/services/middleware/api-middleware.js';
import { ANNOUNCED } from '../constants/we-spin-stream-states.js';
import { FREE_WESPIN } from '../constants/we-spin-boost-constants.js';
import { selectParticipations } from './we-spin-selectors.js';

export const WE_SPIN_BASE_URL = '/we-spin-api';
const ACTION_PREFIX = '@komigen/we-spin';
const REDUCER_NAME = 'WeSpinHomeGame';

// Events
const SET_CURRENT_EVENT_REF = `${ACTION_PREFIX}/CURRENT_EVENT_REF`;
const SET_CURRENT_EVENT = `${ACTION_PREFIX}/CURRENT_EVENT`;

// Selectors
export const selectCurrentEventRef = state => state[REDUCER_NAME].currentEventRef;

export const selectCurrentEvent = createSelector(
	[state => state[REDUCER_NAME].currentEvent, selectCurrentEventRef, selectParticipations],
	(currentEvent, currentEventRef, participations) => {
		const buyInAmount = participations.find(participation => currentEventRef === participation.streamRef)?.buyIn;
		return (
			currentEvent && {
				...currentEvent,
				buyInAmount,
				joined: buyInAmount !== undefined
			}
		);
	}
);

export const setCurrentEventRef = currentEventRef => ({
	type: SET_CURRENT_EVENT_REF,
	payload: {
		currentEventRef
	}
});

export const setCurrentEvent = currentEvent => ({
	type: SET_CURRENT_EVENT,
	payload: currentEvent
});

// Actions
export const fetchCurrentEvent = () => (dispatch, getState) => {
	const currentEventRef = selectCurrentEventRef(getState());
	return dispatch(
		createApiAction({
			endpoint: `${WE_SPIN_BASE_URL}/view/stream?streamRef=${currentEventRef}`,
			onSuccess: response => setCurrentEvent(response),
			onError: basicApiErrorHandler
		})
	);
};

const INIT_STATE = {
	currentEventRef: null,
	currentEvent: null
};

const reducer = (state = INIT_STATE, { type, payload } = {}) => {
	switch (type) {
		case SET_CURRENT_EVENT_REF:
			return {
				...state,
				currentEventRef: payload.currentEventRef
			};
		case SET_CURRENT_EVENT:
			return {
				...state,
				currentEvent: {
					...payload,
					balanceCapMet:
						payload.boost?.type !== FREE_WESPIN && // Filter out free wespins, because it's balance cap will always be met
						payload.balanceCap <= payload.balance + payload.buyinAmounts[0],
					playerCapMet:
						payload.boost?.noPlayers &&
						payload.boost.noPlayers !== 0 &&
						payload.boost.noPlayers <= payload.noParticipants,
					isFreeWeSpin: payload.boost?.type === FREE_WESPIN,
					isEventDisabled: payload.boost?.type === FREE_WESPIN && payload.state === ANNOUNCED
				}
			};
		default:
			return state;
	}
};

reducerRegistry.register(REDUCER_NAME, reducer);

export default reducer;
